import { Component, OnInit, Injector } from '@angular/core';
import { ReportsService, Statuses } from '../reports.service';

@Component({
  selector: 'ga-wo-progress-report-form',
  templateUrl: './ga-wo-progress-report-form.component.html',
  styleUrls: ['../../../dialogs/ga-wo-submit-report-dialog/ga-wo-submit-report-dialog.component.scss',
    '../../../../work-orders.component.scss']
})
export class GaWoProgressReportFormComponent implements OnInit {
  service: ReportsService;

  constructor(injector: Injector) {
    this.service = injector.get(ReportsService);
    this.service.status = Statuses.InProgress;
  }

  ngOnInit() {
    this.service.editForm.get('ActualStartDate').setValue(new Date());
    Promise.all([
      this.service.getStatuses(Statuses.InProgress),
      this.service.getDefaultContacts(),
      this.service.populateContactsList()
    ]);
  }
}
